import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { CardServiceComponent } from '../../components/card-service/card-service.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import ServiceRestServices from '../../services/service-rest.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'booking-reservation',
	templateUrl: './booking-reservation.component.html',
	imports: [
		CommonModule, PanelDirective, LowerCasePipe, TranslatePipe,
		ItemInfoPopoverComponent, LoaderOverlayComponent, ItemErrorComponent,
		CardServiceComponent, ItemNotificationComponent, FormsModule
	]
})
export default class BookingReservationView implements OnInit, OnDestroy {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	onResolve() {
		this.vm.initialized = false;
		this.vm.reservationId = this.angularRoutingHelperService.getRouteParam('reservationId');
		
		this.vm.booking = {};
		this.vm.isOpen = {
			service: true
		};
		this.vm.descMaxLength = 300;
		this.vm.user = this.session.getSession().user;
		
		this.getReservation();
		
		var currentSession = this.session.getSession();
		this.watcher = this.angularHelperService.createInterval(() => {
			var newSession = this.session.getSession();
			if (!this.angularHelperService.isEqual(newSession, currentSession)) {
				this.handleSessionChange(newSession, currentSession);
				currentSession = Object.assign({}, newSession);
			}
		}, 300);
		
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.getPlatformProblemPlaceholderTranslation = this.getPlatformProblemPlaceholderTranslation;
		this.vm.initialized = true;
	}
	
	getPlatformProblemPlaceholderTranslation() {
		if (this.vm.user?.origin == 'siffi.com') {
			return this.angularFilterHelperService.translate('Booking.Problem_Description_Siffi_Placeholder');
		} else {
			return this.angularFilterHelperService.translate('Booking.Problem_Description_Placeholder');
		}
	}
	
	getReservation() {
		var reservationId: any = this.vm.reservationId || this.angularRoutingHelperService.getRouteParam('reservationId');
		this.vm.isProcessing = true;
		this.serviceRestServices.getBookingReservationDetails({ reservationId: reservationId },
			(response) => {
				this.vm.isProcessing = false;
				this.vm.isBookingInitialized = true;
				this.vm.reservation = response;
				this.getBookingDetails();
			},
			(err) => {
				this.vm.isProcessing = false;
				console.error(err);
				this.angularRoutingHelperService.setPath('/');
			}
		);
	}
	
	getBookingDetails() {
		var reservationId: any = this.vm.reservationId || this.angularRoutingHelperService.getRouteParam('reservationId');
		this.vm.isProcessing = true;
		this.serviceRestServices.getBookingDetails({ bookingId: reservationId },
			(response) => {
				this.vm.isProcessing = false;
				this.vm.booking = response;
				if (this.vm.booking.careTakenInfo && this.vm.booking.careTakenInfo.personalCode) {
					this.vm.isForCareTaken = true;
				}
				this.getService();
			},
			(err) => {
				this.vm.isProcessing = false;
				console.error(err);
			}
		);
	}
	
	getService() {
		var serviceId: any = this.vm.booking.service.id;
		this.serviceRestServices.getServiceById({ id: serviceId }, (service) => {
			this.angularHelperService.forEach(service.fieldTranslations, (field) => {
				if (field.language === this.vm.user.deviceLanguage.slice(0, 2)
					&& field.furtherSubcategory === service.furtherSubcategory) service.translation = field.translation;
			});
			this.vm.isAddressRequired = service.customerContactAddressRequired;
			this.vm.service = service || {};
			this.handleBookingInit(this.vm.booking);
		});
	}
	
	handleBookingInit(booking) {
		this.vm.booking = this.handleBookingServicePreparation(booking);
		this.vm.isHomeVisit = this.vm.booking.service && this.vm.booking.service.subcategory === 'HOME_VISITS';
		this.vm.isPrescription = this.vm.booking.type === 'PRESCRIPTION_REQUEST';
	}
	
	handleBookingServicePreparation(booking) {
		if (Object.keys(booking).length === 0) return;
		booking.service.pricing = booking.service.pricing || booking.price || {};
		booking.price = booking.service.pricing.price;
		booking.currency = this.angularFilterHelperService.currency(booking.service.pricing.currency);
		booking.service.userRating = booking.service.userRating || booking.userRating;
		booking.date = moment(booking.scheduledStart).locale(this.vm.user.deviceLanguage.slice(0, 2)).format('dddd, D MMM YYYY');
		booking.start = moment(booking.scheduledStart).format('HH:mm');
		booking.end = moment(booking.scheduledEnd).format('HH:mm');
		booking.duration = moment.duration(moment(booking.scheduledEnd).diff(moment(booking.scheduledStart))).asMinutes();
		
		return booking;
	}
	
	handleSessionChange(newSess, oldSess) {
		if (this.angularHelperService.equals(newSess, oldSess) || !newSess) return;
		this.vm.user = newSess.user;
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.isProcessing) {
			if (!this.vm.booking.comment) this.vm.isOpen.description = true;
			return;
		}
		this.vm.isProcessing = true;
		
		var payload: any = {
			id: this.vm.reservationId,
			comment: this.vm.booking.comment,
			careTakenInfo: {
				name: this.vm.booking.careTakenInfo.name,
				personalCode: this.vm.booking.careTakenInfo.personalCode
			}
		};
		this.serviceRestServices.updateReservedBooking(payload,
			(response) => {
				this.angularRoutingHelperService.setPath(['booking/service/', this.vm.service.id, 'checkout'], false, false, 
					{ bookingId: this.vm.booking.id });
			},
			(err) => {
				console.error(err);
				this.vm.isProcessing = false;
			}
		);
	}
	
}